import { createSlice } from "@reduxjs/toolkit";
import * as R from "ramda";

import { EDITTAG, NEWTAG } from "./tagConstants";
const initialState = {
  status: NEWTAG,
  list: [],

  tag: { id: "", description: "", colour: "" },
};
//

const tagSlice = createSlice({
  name: "tags",
  initialState,
  reducers: {
    setTagList: (state, action) => {
      state.status = NEWTAG;
      state.tag = { id: "", description: "", colour: "" };
      state.list = action.payload;
    },
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setTagToEdit: (state, action) => {
      state.status = EDITTAG;
      state.tag = action.payload;
    },
    setFormInit: (state, action) => {
      state.status = NEWTAG;
      state.tag = { id: "", description: "", colour: "" };
    },

    filterList: (state, action) => {
      // const all = state.allList;
      // const { name, value } = action.payload;
      // if (value === "all") {
      //   state.list = all;
      // } else {
      //   const filtered = filterByPropValue(name, value)(all);
      //   state.list = filtered;
      // }
      // state.page = 1;
      // state.sort = "date";
      // state.asc = true;
    },
  },
});

export const { actions } = tagSlice;
export const {
  setTagList,
  setTagStatus,
  setFormInit,
  filterList,
  setTagToEdit,
} = actions;

export const sendTagForEdit = (item) => (dispatch) => {
  return dispatch(setTagToEdit(item));
};
export const resetTagForm = () => (dispatch) => {
  return dispatch(setFormInit());
};

// selectors

export const selTagsStutus = (state) => state.tags.status;

export const selTagsList = (state) => state.tags.list;
export const selTagId = (state) => state.tags.status;
export const selCurentTag = (state) => state.tags.tag;

const reducer = {
  tags: tagSlice.reducer,
};

export default reducer;
